function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "components",
  stroke: "none",
  strokeWidth: 1,
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Group-2"
}, React.createElement("rect", {
  id: "Rectangle-Copy-14",
  stroke: "currentColor",
  strokeWidth: 2,
  x: 1,
  y: 1,
  width: 14,
  height: 14,
  rx: 2
}), React.createElement("g", {
  id: "action/tick/S-Copy-3",
  transform: "translate(2.000000, 2.000000)"
}, React.createElement("rect", {
  id: "Rectangle",
  x: 0,
  y: 0,
  width: 12,
  height: 12
}), React.createElement("path", {
  d: "M4.51282372,9.625625 C4.31413418,9.625625 4.12393137,9.546625 3.98315134,9.406125 L1.2189704,6.636625 C0.926926718,6.344125 0.926926718,5.869125 1.21946962,5.576125 C1.51201252,5.283625 1.98577226,5.283125 2.27831516,5.576125 L4.51282372,7.814625 L9.72168484,2.594625 C10.0142277,2.301625 10.4879875,2.302125 10.7805304,2.594125 C11.0730733,2.887125 11.0730733,3.362125 10.7810296,3.655125 L5.04249611,9.406125 C4.9022153,9.546625 4.71151327,9.625625 4.51282372,9.625625",
  id: "tick",
  fill: "#FFFFFF"
}))));

var SvgActiveCheckbox = function SvgActiveCheckbox(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgActiveCheckbox, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/active-checkbox.51035f49.svg";
export { ForwardRef as ReactComponent };